import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MatDialog, MatSnackBar, MAT_DIALOG_DATA, MatMenuTrigger } from '@angular/material';
import { Course } from 'src/app/interfaces/course';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms'
import { Observable } from 'rxjs';
import { LearnerService } from '../../services/learner.service';
import { DeleteConfirmModalComponent } from '../../commons/delete-confirm-modal/delete-confirm-modal.component'
import { EncryptDecryptService } from '../../services/encrypt-decrypt.service';
import { PolicyService } from '../../services/policy.service'
import * as _ from 'lodash';
declare var $;
import { Location } from '@angular/common';

@Component({
  selector: 'app-edit-learner-modal',
  templateUrl: './edit-learner-modal.component.html',
  styleUrls: ['./edit-learner-modal.component.scss']
})

export class EditLearnerModalComponent implements OnInit {
  loading: Boolean = false;
  learnerData;
  user;
  passwordMismatch: boolean;
  show: boolean;
  pwd: boolean;
  show1: boolean;
  pwd1: boolean;
  url1: any;
  profileFile: any = [];
  error: any;
  lernerEditForm
  @ViewChild('clickMenuTrigger', { static: false }) public clickMenuTrigger: MatMenuTrigger;
  isPolicy: Boolean = false
  // private readonly clickMenuTrigger: MatMenuTrigger;
  // isPolicy: any;
  // user
  ngOnInit() {
    this.user = JSON.parse(localStorage.userRoles);
    console.log("DATA = ", this.data);
    this.learnerData = JSON.parse(JSON.stringify(this.data));
    this.data.password = this._EncryptDecryptService.decrypt(this.data.password)
    this.data.confirmPassword = this.data.password;
    // this.data.phone=this.data.phone
    $("#password").click(function () {
      $("#password").toggleClass("fa-eye fa-eye-slash");
    });

    $("#cpassword").click(function () {
      $("#cpassword").toggleClass("fa-eye fa-eye-slash");
    });

    // this.currentUser = JSON.parse(localStorage.currentUser);
    this.user = JSON.parse(localStorage.getItem('userRoles'))
    console.log("login user details", this.user);
    this.createForm(this.data)
  }
  constructor(
    public _EncryptDecryptService: EncryptDecryptService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public _learnerService: LearnerService,
    public _location: Location,
    private formBuilder: FormBuilder,
    private _policyService: PolicyService
  ) {
    // NO DEFINITION
  }

  validate(data) {
    console.log("Validating ", data);
    if (!data.name) return false;
    if (!data.email) return false;
    if (!data.password) return false;
    if (!data.confirmPassword) return false;
    if (data.password !== data.confirmPassword) {
      this.passwordMismatch = true;
      return false;
    }
    this.passwordMismatch = false;
    return true;
  }



  //userForm

  createForm(editData?) {
    this.lernerEditForm = this.formBuilder.group({
      name: new FormControl((editData && editData.name) ? editData.name : '', Validators.required),
      email: new FormControl((editData && editData.email) ? editData.email : '', Validators.required),
      //  password:new FormControl((editData && editData.password) ? editData.password : ''),
      password: new FormControl((editData && editData.password) ? editData.password : '', Validators.compose([
        Validators.required,
        this._policyService.patternValidator(/\d/, { hasNumber: true }),
        this._policyService.patternValidator(/[A-Z]/, { hasCapitalCase: true }),
        Validators.minLength(8)
      ])),
      phone: new FormControl((editData && editData.phone) ? editData.phone : ''),
      confirmPassword: new FormControl((editData && editData.confirmPassword) ? editData.confirmPassword : '', Validators.required),
    },
      {
        validator: this._policyService.passwordMatchValidator
      })
  }







  doSubmit() {
    // console.log("Submit In Edit Learner ", this.data, this.learnerData);

    // console.log("EDIT LEARNER FORM ::",this.lernerEditForm.value)

    // console.log("Validating = ", this.validate(this.data));
    // if (!this.validate(this.data)) {
    //   console.log("RETURNING");
    //   return;
    // }

    const learner = new FormData();

    if (this.lernerEditForm.value.name) learner.append('name', this.lernerEditForm.value.name);
    if (this.lernerEditForm.value.email) learner.append('email', this.lernerEditForm.value.email);
    if (this.lernerEditForm.value.password) learner.append('password', this._EncryptDecryptService.encrypt(this.lernerEditForm.value.password));
    if (this.lernerEditForm.value.confirmPassword) learner.append('confirmPassword', this._EncryptDecryptService.encrypt(this.lernerEditForm.value.confirmPassword));
    if (this.lernerEditForm.value.phone) learner.append('phone', this.lernerEditForm.value.phone);
    if (this.data._id) learner.append('_id', this.data._id);
    this.lernerEditForm.value['isPolicy'] = this.isPolicy
    if (this.isPolicy) learner.append('isPolicy', this.lernerEditForm.value.isPolicy)

    if (this.profileFile.length) {
      for (let i = 0; i <= this.profileFile.length; i++) {
        learner.append('profile', this.profileFile[i]);
      }
    }

    console.log("Submit In Edit Learner ", learner, this.isPolicy);

    // Do Submit
    this.loading = true;
    this._learnerService.editLearner(learner).subscribe(learner => {
      this.learnerData = learner;
      console.log("learnerDATA = ", learner);
      this.loading = false;
      this.closoeDialog({
        action: 'edit',
        result: 'success',
        data: this.learnerData
      });
    }, err => {
      this.loading = false;
      this.error = err.msg
    });
  }


  delete() {
    console.warn("DELETING ", this.data._id);

    this.openDialog(DeleteConfirmModalComponent, 'learner').subscribe(confirm => {
      if (confirm == '') return
      else if (confirm == 'yes') {
        this.loading = true;
        this._learnerService.deleteLearner(this.learnerData._id).subscribe(learners => {
          this.loading = false;
          this.closoeDialog({
            action: 'delete',
            result: 'success',
            data: this.learnerData
          });
          this._location.back();
          // http://localhost:4200/jobs/5f59aca6be4a483bbdccaa61?courseType=Level2
        }, err => {
          this.loading = false;
          this.closoeDialog({
            action: 'delete',
            result: 'err',
            data: err
          });
        });
      }
    })
  }

  password() {
    this.show = !this.show;
    this.pwd = !this.pwd;
  }

  cpassword() {
    this.show1 = !this.show1;
    this.pwd1 = !this.pwd1
  }

  public addProfileImage(event: any) {
    this.profileFile = event.target.files;
    console.log('This.profile Pic', this.profileFile);
    if (event.target.files && event.target.files[0]) {
      let reader = new FileReader();
      reader.onload = (event: any) => {
        this.url1 = event.target.result;
      }
      reader.readAsDataURL(event.target.files[0]);
    }
  }

  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, { data, width: '500px', height: '600px' });
    return dialogRef.afterClosed();
  }

  onKeyPress(event) {
    console.log("event while change password", event);

    this.isPolicy = true
    this.clickMenuTrigger.openMenu();
    // console.log("value of password", this.passwords);
  }
  closeModel() {
    this.clickMenuTrigger.closeMenu();
  }


  closoeDialog(result) {
    this.dialogRef.close(result);
  }
  onNoClick(): void {
    this.dialogRef.close();
  }

  // onKeyPress(x) {
  //   this.isPolicy = true
  //   this.clickMenuTrigger.openMenu();
  //   // console.log("value of password", this.passwords);
  // }
  // closeModel() {
  //   this.clickMenuTrigger.closeMenu();
  // }

}
